export const STORAGE_KEYS = {
  AUTH_TOKEN: "authToken",
  THEME: "theme",
}

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  ADMIN: "/admin",
}

export const API_TIMEOUT = 5000

export const INITIAL_PROJECT_FORM = {
  title: "",
  github: "",
  image: "",
  skills: "",
  demoUrl: "",
  listed: true,
}

export const SOCIAL_LINKS = [
  { name: "GitHub", url: "https://github.com/SamAl-Bayati", icon: "FaGithub" },
  { name: "LinkedIn", url: "https://linkedin.com/in/sam-al-bayati", icon: "FaLinkedin" },
  { name: "Email", url: "mailto:sam.albayatii@gmail.com", icon: "FaEnvelope" },
]

export const SITE_INFO = {
  name: "Sam Al-Bayati",
}

export {
  LANDING_CUBE_CONFIG,
  LANDING_CUBE_EDGES,
  LANDING_CUBE_VERTICES,
} from "./cube"
